import autolinkAndSetTarget from '@crossiety/lit-components//lib/autolink_and_set_target.js';
import Truncate from '../truncate/element.js';
import style from './style.lit.css';

/**
 * Use this component for body part of Card, Comment, etc...
 *
 * This component will:
 *   * auto detect links in text and convert them to `<a>` tags
 *   * has ability to truncate content by line rows
 *
 * @prop autoTruncate - Should truncating functionality be initially turned on
 */
export default class AdvancedBody extends Truncate {
  static styles = [Truncate.styles, style];

  static properties = {
    autoTruncate: { type: Boolean },
  };

  /** @internal */
  get autoLinkOptions() {
    return {
      stripPrefix: false,
      stripTrailingSlash: false,
      newWindow: false,
    };
  }

  /** @internal */
  get innerClass() {
    return {
      inner: true,
      truncated: this.truncated,
      'truncate-disabled': !this.autoTruncate,
    };
  }

  onSlotChange() {
    this.autolink();
    super.onSlotChange();
  }

  autolink() {
    if (this.autolinkLock) {
      this.autolinkLock = false;
      return;
    }

    this.autolinkLock = true;
    this.innerHTML = autolinkAndSetTarget(this.innerHTML, this.autoLinkOptions);

    this.dispatchEvent(
      new Event('autolink:done', { bubbles: true, cancelable: false })
    );
  }

  shouldTruncate() {
    return this.autoTruncate && super.shouldTruncate();
  }
}

customElements.get('xs-advanced-body') ||
  customElements.define('xs-advanced-body', AdvancedBody);
